import { MsalInterceptorConfiguration } from "@azure/msal-angular";
import { AppConfigService } from "../services/app-config.service";
import { InteractionType } from "@azure/msal-browser";

/**
 * Factory function to create MSALInterceptorConfiguration.
 * @param appConfigService - The AppConfigService instance.
 * @returns The MSALInterceptorConfiguration object.
 */
export function MSALInterceptorConfigFactory(appConfigService: AppConfigService): MsalInterceptorConfiguration {
    // Create a protected resource map from the appConfigService
    const protectedResourceMap = new Map<string, Array<string>>(appConfigService.get().msal.interceptor.protectedResourceMap);

    // Return the MSALInterceptorConfiguration object
    return {
        // Set the interaction type based on the appConfigService
        interactionType: appConfigService.get().msal.interceptor.interactionType as InteractionType.Redirect | InteractionType.Popup,
        protectedResourceMap
    };
}